import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logout from '../components/Auth/Logout';
import { ciosv2Logout, ciosv2Authorize } from '../actions/api/apis';

class V2LogoutContainer extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = props;
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'LOGOUT' });
    // if (logoutExec) {
    //   dispatch(ciosv2Logout(apiToken));
    // }
    // if (!logoutExec && !isLogin) {
    //   window.location.href = PAGE_PATH.DS_ROOT;
    // }
  }

  shouldComponentUpdate(props) {
    const { apiToken, logoutExec, redirectLoginPage, dispatch } = props;
    if (logoutExec) {
      dispatch(ciosv2Logout(apiToken));
    }
    // if (!isLogin) {
    //   window.location.href = PAGE_PATH.DS_ROOT;
    // }
    if (redirectLoginPage) {
      dispatch(ciosv2Authorize());
    }
    return true;
  }

  render() {
    return <Logout />;
  }
}

V2LogoutContainer.propTypes = {
  redirectLoginPage: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  // isLogin: PropTypes.bool.isRequired,
  logoutExec: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  redirectLoginPage: state.main.redirectLoginPage,
  apiToken: state.main.apiToken,
  // isLogin: state.main.isLogin,
  logoutExec: state.main.logoutExec,
});
export default connect(mapStateToProps)(V2LogoutContainer);
